import React from 'react';

const Vision: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-20">
      <h1 className="font-serif text-4xl text-ink mb-4">Vision</h1>
      <p className="text-inkSoft text-lg max-w-3xl mb-8">
        Our vision for the future of clinical intelligence.
      </p>
      <div className="bg-white border border-rule rounded-xl p-8">
        <p className="text-gray-500">Content coming soon...</p>
      </div>
    </div>
  );
};

export default Vision;
